<template>
  <div class="containercard">
    <div :class="validation">
      <div class="titulo">
        <h1>SDRCTP</h1>
        <h3 v-if="error_validation">E-mail ou senha invalido!</h3>
      </div>

      <form @submit.prevent.="submit">
        <div class="inputform">
          <p>Cadastro</p>
          <input type="text" name="" id="cadastro" v-model="user.email" />
          <p>Senha</p>
          <input type="password" name="" id="senha" v-model="user.password" />
        </div>
        <button type="submit" @click="trocarValor" class="btlogin">
          Login
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import httpAuth from "../services/auth/index"

export default {
  components: {},
  computed: {
    validation() {
      if (this.error_validation) {
        return `card error_validation`;
      }

      return "card";
    },
  },
  methods: {
    async submit() {
      try {
        // validando dados
        if (!this.user.email || !this.user.password) {
          this.toast.error("Email ou senha inválidos", {
            timeout: 2250,
          });
          return (this.error_validation = true);
        }

        this.error_validation = false;
         

        const { token, user } = await httpAuth.auth(this.user.email, this.user.password)

        if (!token) {
          return (this.error_validation = !this.error_validation);
        }

        this.error_validation = false;

        sessionStorage.setItem("token", token);

        this.$store.dispatch("userLogged", user);

        this.toast.success("Logado com sucesso", {
          timeout: 2250,
        });
        return this.$router.push({ name: "Scanner" });
      } catch (error) {

        return (this.error_validation = !this.error_validation);
      }
    },

    trocarValor() {
      this.error_validation = !this.error_validation;
    },
  },

  data() {
    return {
      user: {
        email: "",
        password: "",
      },
      error_validation: false,
    };
  },
  computed: {
    toast() {
      return useToast();
    },
  },
};
</script>

<style scoped>
.containercard {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card {
  width: 25rem;
  height: 30rem;
  background-color: var(--white);
  box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.65);
  border-radius: 1rem;
  padding: 1.5rem;
  display: grid;
  justify-content: center;
}
.error_validation {
  animation: invalid 0.2s ease-in-out;
  transform-origin: center;
  transform-box: fill-box;

  box-shadow: 1px 2px 16px rgba(255, 115, 0, 0.733) !important;
}

@keyframes invalid {
  0% {
    transform: translateX(-20px);
  }
  25% {
    transform: translateX(20px);
  }
  50% {
    transform: translateX(-20px);
  }
  100% {
    transform: translateX(20px);
  }
}

.titulo {
  width: 100%;
  height: 10rem;
  display: grid;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.titulo h3 {
  color: var(--notifyDelay);
}
.inputform input {
  width: 100%;
  font-size: 1.5rem;
  border: none;
  margin-bottom: 10px;
  border-bottom: 2px solid var(--colorPrimary);
  padding: 0.5rem 0;
  outline: none;
}

.btlogin {
  font-size: 1.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  background-color: var(--colorPrimary);
  color: var(--white);
  transition: filter 0.4s;
}

.btlogin:hover {
  filter: brightness(0.8);
}

.titulopagina {
  justify-content: center;
  align-content: center;
  display: flex;
  padding-top: 1rem;
}

@media only screen and (max-width: 600px) {
  .card {
    width: 100%;
    height: 100vh;
    border-radius: 0rem;
  }

  .containercard {
    align-items: flex-start;
  }

  form {
    padding-bottom: 5rem;
  }

  .inputform input {
    border-bottom: 1px solid var(--colorPrimary);
  }

  .inputform input:focus {
    border-bottom: 2px solid var(--unityCd);
  }
}
</style>
